// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.blockument .blockument-tab-container {
   display: flex;
   flex-direction: row;
   flex: 1 1 400px;
   overflow-x: auto;
   padding: var(--padding-sm);
}

.blockument .blockument-tab-container button {
   border-radius: var(--border-radius) var(--border-radius) 0px 0px;
   padding: var(--padding-sm);
   border: 1px solid var(--frame-bg);
   color: var(--text);
   margin: 0;
   min-width: 75px;
}

.blockument .blockument-tab-container .tab-button {
   background-color: var(--window-bg);
   text-align: left;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   display: block;
   max-width: 200px;
}

.blockument .blockument-tab-container .tab-button:hover {
   background-color: var(--tab-hovered);
}

.blockument .blockument-tab-container .tab-button-active {
   background-color: var(--tab-unfocused-active);
   text-align: left;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   display: block;
   max-width: 200px;  
}


@media only screen and (min-width: 360px) and (max-width: 480px) {
   .blockument .blockument-tab-container {
      display: flex;
      flex-direction: row;
      flex: 1 1 auto;
      max-height: 50px;
      overflow-x: auto;
   }

   .blockument .blockument-tab-container button {
      border-radius: var(--border-radius) var(--border-radius) 0px 0px;
      padding: var(--padding);
      border: 1px solid var(--frame-bg);
      color: var(--text);
      margin: 0;
      min-width: 35px;
   }

   .blockument .blockument-tab-container .tab-button {
      background-color: var(--window-bg);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      max-width: 100px;
   }

   .blockument .blockument-tab-container .tab-button:hover {
      background-color: var(--button-primary);
   }

   .blockument .blockument-tab-container .tab-button-active {
      background-color: var(--tab-unfocused-active);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      max-width: 100px;
   }
}

@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {
   .blockument .blockument-tab-container {
      display: flex;
      flex-direction: row;
      flex: 1 1 auto;
      max-height: 50px;
      overflow-x: auto;
   }

   .blockument .blockument-tab-container button {
      border-radius: var(--border-radius) var(--border-radius) 0px 0px;
      padding: var(--padding);
      border: 1px solid var(--frame-bg);
      color: var(--text);
      margin: 0;
      min-width: 35px;
   }

   .blockument .blockument-tab-container .tab-button {
      background-color: var(--window-bg);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      max-width: 100px;
   }

   .blockument .blockument-tab-container .tab-button:hover {
      background-color: var(--button-primary);
   }

   .blockument .blockument-tab-container .tab-button-active {
      background-color: var(--tab-unfocused-active);
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      max-width: 100px;
   }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/Tabs.css"],"names":[],"mappings":";AACA;GACG,aAAa;GACb,mBAAmB;GACnB,eAAe;GACf,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG,gEAAgE;GAChE,0BAA0B;GAC1B,iCAAiC;GACjC,kBAAkB;GAClB,SAAS;GACT,eAAe;AAClB;;AAEA;GACG,kCAAkC;GAClC,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,oCAAoC;AACvC;;AAEA;GACG,6CAA6C;GAC7C,gBAAgB;GAChB,gBAAgB;GAChB,mBAAmB;GACnB,uBAAuB;GACvB,cAAc;GACd,gBAAgB;AACnB;;;AAGA;GACG;MACG,aAAa;MACb,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,gBAAgB;GACnB;;GAEA;MACG,gEAAgE;MAChE,uBAAuB;MACvB,iCAAiC;MACjC,kBAAkB;MAClB,SAAS;MACT,eAAe;GAClB;;GAEA;MACG,kCAAkC;MAClC,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,gBAAgB;GACnB;;GAEA;MACG,uCAAuC;GAC1C;;GAEA;MACG,6CAA6C;MAC7C,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,gBAAgB;GACnB;AACH;;AAEA;GACG;MACG,aAAa;MACb,mBAAmB;MACnB,cAAc;MACd,gBAAgB;MAChB,gBAAgB;GACnB;;GAEA;MACG,gEAAgE;MAChE,uBAAuB;MACvB,iCAAiC;MACjC,kBAAkB;MAClB,SAAS;MACT,eAAe;GAClB;;GAEA;MACG,kCAAkC;MAClC,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,gBAAgB;GACnB;;GAEA;MACG,uCAAuC;GAC1C;;GAEA;MACG,6CAA6C;MAC7C,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;MACvB,cAAc;MACd,gBAAgB;GACnB;AACH","sourcesContent":["\r\n.blockument .blockument-tab-container {\r\n   display: flex;\r\n   flex-direction: row;\r\n   flex: 1 1 400px;\r\n   overflow-x: auto;\r\n   padding: var(--padding-sm);\r\n}\r\n\r\n.blockument .blockument-tab-container button {\r\n   border-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n   padding: var(--padding-sm);\r\n   border: 1px solid var(--frame-bg);\r\n   color: var(--text);\r\n   margin: 0;\r\n   min-width: 75px;\r\n}\r\n\r\n.blockument .blockument-tab-container .tab-button {\r\n   background-color: var(--window-bg);\r\n   text-align: left;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   display: block;\r\n   max-width: 200px;\r\n}\r\n\r\n.blockument .blockument-tab-container .tab-button:hover {\r\n   background-color: var(--tab-hovered);\r\n}\r\n\r\n.blockument .blockument-tab-container .tab-button-active {\r\n   background-color: var(--tab-unfocused-active);\r\n   text-align: left;\r\n   overflow: hidden;\r\n   white-space: nowrap;\r\n   text-overflow: ellipsis;\r\n   display: block;\r\n   max-width: 200px;  \r\n}\r\n\r\n\r\n@media only screen and (min-width: 360px) and (max-width: 480px) {\r\n   .blockument .blockument-tab-container {\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex: 1 1 auto;\r\n      max-height: 50px;\r\n      overflow-x: auto;\r\n   }\r\n\r\n   .blockument .blockument-tab-container button {\r\n      border-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n      padding: var(--padding);\r\n      border: 1px solid var(--frame-bg);\r\n      color: var(--text);\r\n      margin: 0;\r\n      min-width: 35px;\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button {\r\n      background-color: var(--window-bg);\r\n      text-align: left;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      display: block;\r\n      max-width: 100px;\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button:hover {\r\n      background-color: var(--button-primary);\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button-active {\r\n      background-color: var(--tab-unfocused-active);\r\n      text-align: left;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      display: block;\r\n      max-width: 100px;\r\n   }\r\n}\r\n\r\n@media only screen and (min-height: 360px) and (max-height: 480px) and (orientation: landscape) {\r\n   .blockument .blockument-tab-container {\r\n      display: flex;\r\n      flex-direction: row;\r\n      flex: 1 1 auto;\r\n      max-height: 50px;\r\n      overflow-x: auto;\r\n   }\r\n\r\n   .blockument .blockument-tab-container button {\r\n      border-radius: var(--border-radius) var(--border-radius) 0px 0px;\r\n      padding: var(--padding);\r\n      border: 1px solid var(--frame-bg);\r\n      color: var(--text);\r\n      margin: 0;\r\n      min-width: 35px;\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button {\r\n      background-color: var(--window-bg);\r\n      text-align: left;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      display: block;\r\n      max-width: 100px;\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button:hover {\r\n      background-color: var(--button-primary);\r\n   }\r\n\r\n   .blockument .blockument-tab-container .tab-button-active {\r\n      background-color: var(--tab-unfocused-active);\r\n      text-align: left;\r\n      overflow: hidden;\r\n      white-space: nowrap;\r\n      text-overflow: ellipsis;\r\n      display: block;\r\n      max-width: 100px;\r\n   }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
